module.exports = __webpack_public_path__ + "img/EPG-LOGO.6cc26932.png";